const contents = {
  HEADER: {
    MENU: {
      SEARCH: "CERCAR",
      ABOUT_US: "SOBRE NOSALTRES",
      OPINION: "OPINIÓ",
      SIGN_IN: "ACCÉS EMPRESA",
      MANUAL: "MANUAL"
    }
  },
  FOOTER: {
    MENU: {
      PRIVACY_POLICY: "POLÍTICA DE PRIVACITAT",
      TERMS_OF_SERVICE: "TERMES LEGALS",
      COOKIE_POLICY: "POLÍTICA DE COOKIES"
    }
  },
  HOME: {
    TITLE: "Programa d’innocuïtat alimentària",
    SUBTITLE: "Troba aquest distintiu als teus establiments de confiança",
    VIDEO: "Fes clic aquí per veure vídeo"
  },
  SEARCH: {
    TITLE: "CERCAR",
    CONTENT:
      "Menjaràs fora? Coneix si el restaurant, hotel o càtering té una bona higiene i segueix els estàndards de qualitat marcats pel Control Oficial.",
    FILTERS: {
      NAME: "Nom",
      ADDRESS: "Direcció",
      SCORE: "Puntuació"
    },
    RESULTS: {
      MORE_INFO: "MÉS INFO",
      VIEW_MORE: "VEURE MÉS"
    }
  },
  ABOUT_US: {
    TITLE: "Sobre nosaltres",
    CONTENT: {
      P1:
        "SALUT PÚBLICA és l'àrea de la Conselleria de la Salut del  Govern de les Illes Balears encarregada de vetllar i promoure la innocuïtat alimentària.",
      P2:
        "El PROGRAMA QxQ és el resultat de la investigació i consens tècnic per empoderar a les empreses  de  la cadena alimentària i fer transparents els seus processos d'higiene per facilitar l'elecció dels consumidors."
    },
    Q1: {
      TITLE: "Q de Quantificació",
      CONTENT:
        "Fa referència a la verificació de l'autocontrol que realitzen les empreses  alimentàries, amb una puntuació que va de 1 (molt desfavorable) a 5 (excel·lent) i que serà consensuada per tècnics validadors externs i de Salut Pública."
    },
    Q2: {
      TITLE: "Q de Qualificació",
      CONTENT:
        "Fa referència al fet que les empreses i els consumidors, locals o turistes, poden comentar i qualificar l'estratègia del Programa QxQ per una millora contínua de la innocuïtat alimentària en les Illes Balears."
    }
  },
  OPINION: {
    TITLE: "La teva opinió",
    CONTENT:
      "Com veus aquesta puntuació? Tens suggeriments sobre el projecte? Envia'ns un missatge amb els teus comentaris i ajuda'ns a millorar!",
    FORM: {
      NAME: "Nom",
      EMAIL: "Email",
      MESSAGE: "Missatge",
      SUBMIT: "ENVIAR"
    },
    FEEDBACK: "Gràcies per compartir la teva opinió amb nosaltres!"
  },
  FACILITY: {
    RELATED: "També et poden interessar:",
    ADDRESS: "Direcció",
    CONTACT: "Contacte",
    EXPLAINATION:
      "* La puntuació valora la darrera verificació del autocontrol feta per l'establiment i consensuada pels tècnics amb la diligència deguda. En tot cas, l’empresa que gestiona l'establiment és la responsable de garantir el compliment de tots els requisits d'higiene alimentària."
  },
  BLOCK: {
    FIRST: {
      1: `Les infraestructures i equipaments d'aquest establiment no són adequades per a les activitats que s'hi desenvolupen.`,
      2: `Les infraestructures i equipaments d'aquest establiment s'han d'actualitzar i el seu nivell de manteniment i neteja han de millorar per evitar riscos en la seguretat alimentària dels productes que s'hi elaboren.`,
      3: `Les infraestructures i equipaments d'aquest establiment permeten unes condicions acceptables per a l'elaboració d'aliments tot i haver-hi un marge de millora en alguns aspectes.`,
      4: `Les infraestructures i equipaments d'aquest establiment permeten unes condicions adequades per a l'elaboració d'aliments, estan en un bon estat de manteniment i la seva neteja i ús són correctes.`,
      5: `Les infraestructures i equipaments d'aquest establiment permeten unes condicions adequades per a l'elaboració d'aliments, estan en molt bon estat de manteniment i neteja i el seu ús és òptim.`
    },
    SECOND: {
      1: `Les pràctiques d'elaboració i manipulació no permeten preparar aliments segurs per al consumidor. Els manipuladors d'aliments no estan formats.`,
      2: `S'han de millorar les pràctiques d'elaboració i manipulació per poder preparar aliments segurs per al consumidor. La formació dels manipuladors d'aliments ha de millorar.`,
      3: `Les pràctiques d'elaboració i manipulació d'aliments permeten preparar el menjar d'una manera acceptable. No obstant això, hi ha punts de millora importants que s'han de corregir.`,
      4: `Les pràctiques d'elaboració i manipulació d'aliments són adequades. Les mesures de control de riscos són suficients i la formació dels manipuladors és correcta.`,
      5: `Les pràctiques d'elaboració i manipulació d'aliments són molt bones. Les mesures de control de riscos són òptimes i els manipuladors estan degudament formats.`
    },
    THIRD: {
      1: `Alguns dels plans i registres d'autocontrol no es corresponen amb la realitat, no inclouen totes les activitats de l'establiment i no estan correctament emplenats de manera que no permeten fer un seguiment de les activitats que s'hi desenvolupen ni confiar en els procediments de gestió.`,
      2: `Alguns dels plans i registres d'autocontrol no es corresponen amb la realitat, no inclouen totes les activitats de l'establiment o no estan correctament emplenats de manera que no permeten fer un bon seguiment de les activitats que s'hi desenvolupen ni confiar en la seva gestió.`,
      3: `En general, els plans i registres d'autocontrol es corresponen amb la realitat, inclouen totes les activitats de l'establiment, estan correctament emplenats i permeten un seguiment de les activitats que s'hi desenvolupen. No obstant això, hi ha aspectes dels plans o dels registres que poden millorar.`,
      4: `Els plans i registres d'autocontrol es corresponen amb la realitat, inclouen totes les activitats de l'establiment, estan correctament emplenats i permeten un seguiment òptim de les activitats que s'hi desenvolupen.`,
      5: `Els plans i registres d'autocontrol es corresponen amb la realitat, inclouen totes les activitats de l'establiment, estan correctament emplenats, permeten un seguiment òptim de les activitats que s'hi desenvolupen i tenir una confiança adequada en els procediments de gestió.`
    }
  },
  SCORES: {
    5: "EXCELENT",
    4: "BO",
    3: "REGULAR",
    2: "DEFICIENT",
    1: "MOLT\nDEFICIENT"
  },
  UPDATED: "ACTUALITZAT"
};

export default contents;



// WEBPACK FOOTER //
// ./src/services/translation/contents.es_CA.js